import { useState, useEffect } from "react";
import EventButton from "./EventButton";

const passOptionsPro = {
  success: [],
  common: ["corner", "clearance", "cross", "assist"],
};

const passOptions = {
  success: ["key_pass", "assist"],
  common: ["free_kick", "penalty", "corner"],
};

const eventFlows = {
  pass: {
    initial: ["success", "fail"],
    success: [...passOptions.common, ...passOptions.success],
    fail: [...passOptions.common],
  },
  shot: {
    initial: ["success", "fail"],
    success: ["goal", "free_kick", "penalty", "corner"],
    fail: ["free_kick", "penalty", "corner"],
  },
  save: {
    initial: null,
    success: null,
    fail: null,
  },
  success_duel: {
    initial: null,
    success: null,
    fail: null,
  },
  foul: {
    initial: ["offside"],
    offside: null,
  },
  card: {
    initial: ["yellow_card", "red_card"],
    yellow_card: null,
    red_card: null,
  },
};

const eventFlowsPro = {
  pass: {
    initial: ["success", "fail"],
    success: ["clearance", "cross", "key_pass", "assist"],
    fail: ["clearance", "cross", "key_pass", "assist"],
  },
  block_shot: {
    initial: null,
    success: null,
    fail: null,
  },
  recovery: {
    initial: null,
    success: null,
    fail: null,
  },
  interception: {
    initial: null,
    success: null,
    fail: null,
  },
  dribble: {
    initial: ["success", "fail"],
    success: null, // null means flow ends here
    fail: null,
  },
  free_kick: {
    initial: ["success", "fail"],
    success: null,
    fail: null,
  },
  tackle: {
    initial: ["success", "fail"],
    success: null,
    fail: null,
  },
  corner: {
    initial: ["success", "fail"],
    success: null,
    fail: null,
  },
  penalty: {
    initial: ["success", "fail"],
    success: null,
    fail: null,
  },
  azamat: {
    initial: ["success", "fail"],
    success: null,
    fail: null,
  },
  shot: {
    initial: ["success", "fail"],
    success: ["goal", "by_head"],
    fail: ["goal", "by_head"],
  },
  save: {
    initial: null,
    success: null,
    fail: null,
  },
  duel_success: {
    initial: null,
    success: null,
    fail: null,
  },
  foul: {
    initial: ["offside"],
    success: null,
    fail: null,
  },
  card: {
    initial: ["yellow_card", "red_card"],
    yellow_card: null,
    red_card: null,
  },
};

const normalKeys = {
  pass: {
    key: "1",
    options: [
      {
        name: "free_kick",
        key: "1",
      },
      {
        name: "penalty",
        key: "2",
      },
      {
        name: "corner",
        key: "3",
      },
      {
        name: "key_pass",
        key: "4",
      },
      {
        name: "assist",
        key: "5",
      },
    ],
  },
  block_shot: {
    key: "K",
  },
  recovery: {
    key: "O",
  },
  interception: {
    key: "I",
  },
  dribble: {
    key: "G",
  },
  free_kick: {
    key: "R",
  },
  tackle: {
    key: "J",
  },
  corner: {
    key: "T",
  },
  penalty: {
    key: "Y",
  },
  azamat: {
    key: "U",
  },
  shot: {
    key: "Q",
    options: [
      {
        name: "goal",
        key: "E",
      },
      {
        name: "free_kick",
        key: "1",
      },
      {
        name: "penalty",
        key: "2",
      },
      {
        name: "corner",
        key: "3",
      },
    ],
  },
  save: {
    key: "L",
  },
  duel_success: {
    key: "P",
  },
  foul: {
    key: "A",
    options: [
      {
        name: "offside",
        key: "S",
      },
    ],
  },
  card: {
    key: "0",
    options: [
      { name: "yellow_card", key: "1" },
      { name: "red_card", key: "2" },
    ],
  },
};

const proKeys = {
  pass: {
    key: "1",
    options: [
      {
        name: "clearance",
        key: "2",
      },
      {
        name: "key_pass",
        key: "4",
      },
      {
        name: "cross",
        key: "3",
      },
      {
        name: "assist",
        key: "5",
      },
    ],
  },
  block_shot: {
    key: "K",
  },
  recovery: {
    key: "O",
  },
  interception: {
    key: "I",
  },
  dribble: {
    key: "G",
  },
  free_kick: {
    key: "R",
  },
  tackle: {
    key: "J",
  },
  corner: {
    key: "T",
  },
  penalty: {
    key: "Y",
  },
  shot: {
    key: "Q",
    options: [
      {
        name: "goal",
        key: "E",
      },
      {
        name: "by_head",
        key: "W",
        displayName: "Headshot",
      },
    ],
  },
  save: {
    key: "L",
  },
  duel_success: {
    key: "P",
  },
  foul: {
    key: "A",
    options: [
      {
        name: "offside",
        key: "S",
      },
    ],
  },
  card: {
    key: "0",
    options: [
      { name: "yellow_card", key: "1" },
      { name: "red_card", key: "2" },
    ],
  },
};

const eventButtonsPro = [
  { label: "Hide", key: "Escape", value: "esc" },
  { label: "Pass", key: "1", value: "pass" },
  { label: "Block shot", key: "K", value: "block_shot" },
  { label: "Recovery", key: "O", value: "recovery" },
  { label: "Interception", key: "I", value: "interception" },
  { label: "Dribble", key: "G", value: "dribble" },
  { label: "Free kick", key: "R", value: "free_kick" },
  { label: "Tackle", key: "J", value: "tackle" },
  { label: "Corner", key: "T", value: "corner" },
  { label: "Penalty", key: "Y", value: "penalty" },
  { label: "Azamat throwin", key: "U", value: "azamat" },
  { label: "Shot", key: "Q", value: "shot" },
  { label: "Save", key: "L", value: "save" },
  { label: "Duel success", key: "P", value: "duel_success" },
  { label: "Foul", key: "A", value: "foul" },
  { label: "Card", key: "0", value: "card" },
];

const eventButtons = [
  { label: "Hide", key: "Escape", value: "esc" },
  { label: "Pass", key: "1", value: "pass" },
  { label: "Save", key: "L", value: "save" },
  { label: "Shot", key: "Q", value: "shot" },
  { label: "Success Duel", key: "P", value: "success_duel" },
  { label: "Foul", key: "A", value: "foul" },
  { label: "Card", key: "0", value: "card" },
];

const EventControls = ({
  isPro,
  addNewEvent,
  onEventTimeCapture,
  onEventTimeCaptureClear,
}) => {
  const [currentEvent, setCurrentEvent] = useState(null);
  const [currentStep, setCurrentStep] = useState("initial");
  const [selectedOptions, setSelectedOptions] = useState({});
  const [canAddEvent, setCanAddEvent] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [multipleSelections, setMultipleSelections] = useState(new Set());
  const [isFinalStep, setIsFinalStep] = useState(false);
  const [shouldHideButtons, setShouldHideButtons] = useState(false);
  const [keys, setKeys] = useState(normalKeys);

  useEffect(() => {
    if (isPro) setKeys(proKeys);
    else setKeys(normalKeys);
  }, [isPro]);

  // Helper function to check if current step is final
  const checkIsFinalStep = (event, step) => {
    // TODO: used same condition
    if (isPro) {
      return (
        (event === "pass" && ["success", "fail"].includes(step)) ||
        (event === "shot" && ["success", "fail"].includes(step)) ||
        event === "foul" ||
        event === "card"
      );
    }
    return (
      (event === "pass" && ["success", "fail"].includes(step)) ||
      (event === "shot" && ["success", "fail"].includes(step)) ||
      event === "foul" ||
      event === "card"
    );
  };

  const handleAddEvent = () => {
    addNewEvent(currentEvent, selectedOptions, multipleSelections, () => {});
    handleEscape();
  };

  const handleEventClick = (eventType) => {
    setCurrentEvent(eventType);
    setCurrentStep("initial");
    setSelectedOptions({});
    setIsFinalStep(false);

    // Capture the current time when event is first selected
    if (onEventTimeCapture) {
      onEventTimeCapture();
    }

    // If the event has no flow (all nulls), enable Add Event immediately
    const flows = isPro ? eventFlowsPro : eventFlows;
    if (flows[eventType]?.initial === null) {
      setCanAddEvent(true);
      setCurrentStep(null);
    } else if (eventType === "foul" || eventType === "card") {
      setCanAddEvent(true);
      setIsFinalStep(checkIsFinalStep(eventType));
    } else {
      setCanAddEvent(false);
    }
  };

  const handleOptionClick = (option) => {
    if (isFinalStep) {
      // Toggle the selection in multipleSelections
      setMultipleSelections((prev) => {
        const newSelections = new Set(prev);
        if (newSelections.has(option)) {
          newSelections.delete(option);
        } else {
          newSelections.add(option);
        }
        return newSelections;
      });
      setCanAddEvent(true);
    } else {
      const flows = isPro ? eventFlowsPro : eventFlows;
      setSelectedOptions((prev) => ({
        ...prev,
        [currentStep]: option,
      }));

      const nextOptions = flows[currentEvent]?.[option];
      if (typeof nextOptions === "function") {
        const options = nextOptions(selectedOptions);
        if (options.length > 0) {
          setCurrentStep(option);
          setMultipleSelections(new Set());
          const newIsFinalStep = checkIsFinalStep(currentEvent, option);
          setIsFinalStep(newIsFinalStep);
          if (newIsFinalStep) {
            setCanAddEvent(true);
          }
        }
      } else if (nextOptions === null) {
        setCanAddEvent(true);
        setCurrentStep(null);
      } else if (nextOptions) {
        setCurrentStep(option);
        setMultipleSelections(new Set());
        const newIsFinalStep = checkIsFinalStep(currentEvent, option);
        setIsFinalStep(newIsFinalStep);
        if (newIsFinalStep) {
          setCanAddEvent(true);
        }
      } else {
        setCanAddEvent(true);
        setCurrentStep(null);
      }
    }
  };

  const handleEscape = () => {
    if (currentEvent || Object.keys(selectedOptions).length > 0) {
      // Clear current selections
      setCurrentEvent(null);
      setCurrentStep("initial");
      setSelectedOptions({});
      setCanAddEvent(false);
      setMultipleSelections(new Set()); // Clear multiple selections

      // Clear the captured time when clearing event selections
      if (onEventTimeCaptureClear) {
        onEventTimeCaptureClear();
      }
    } else {
      // Hide the component
      setIsVisible(false);
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA"
      ) {
        return;
      }

      // Handle Escape key
      if (event.key === "Escape") {
        handleEscape();
        return;
      }

      // Handle Backspace key to remove last item from history
      if (event.key === "Backspace") {
        // First check if we have multiple selections
        if (multipleSelections.size > 0) {
          // Remove the last added item from multipleSelections
          const selectionsArray = Array.from(multipleSelections);
          const newSelections = new Set(selectionsArray.slice(0, -1));
          setMultipleSelections(newSelections);
          return;
        }

        // If no multiple selections, remove the last step from selectedOptions
        if (Object.keys(selectedOptions).length > 0) {
          const steps = Object.keys(selectedOptions);
          const lastStep = steps[steps.length - 1];

          const newSelectedOptions = { ...selectedOptions };
          delete newSelectedOptions[lastStep];
          setSelectedOptions(newSelectedOptions);

          // If we removed the last step, go back to the previous step
          if (steps.length > 1) {
            setCurrentStep(steps[steps.length - 2]);
            setCanAddEvent(false);
          } else if (currentEvent) {
            // If we're back to just the event, set step to initial
            setCurrentStep("initial");
            setCanAddEvent(false);
          }

          // Reset isFinalStep based on the new state
          setIsFinalStep(
            checkIsFinalStep(currentEvent, steps[steps.length - 2])
          );
          return;
        }

        // If no selections left but we have an event, clear the event
        if (currentEvent) {
          setCurrentEvent(null);
          setCurrentStep("initial");
          setCanAddEvent(false);

          // Clear the captured time when clearing the event
          if (onEventTimeCaptureClear) {
            onEventTimeCaptureClear();
          }
          return;
        }
      }

      // If component is hidden, only respond to Ctrl + E
      if (!isVisible) {
        if (event.ctrlKey && event.key.toLowerCase() === "e") {
          event.preventDefault(); // Prevent default browser behavior
          setIsVisible(true);
        }
        return;
      }

      const flows = isPro ? eventFlowsPro : eventFlows;
      // Rest of the existing key handling logic
      if (currentEvent && currentStep) {
        let options = flows[currentEvent]?.[currentStep];
        // if (typeof options === "function") {
        //   options = options(selectedOptions);
        // }
        options = options || [];
        if (
          options.length === 2 &&
          options.includes("success") &&
          options.includes("fail")
        ) {
          if (event.key === "=" || event.key === "+")
            handleOptionClick("success");
          else if (event.key === "-") handleOptionClick("fail");
        }
        const option = keys[currentEvent]?.options?.find(
          (option) => option.key.toLowerCase() === event.key.toLowerCase()
        );
        if (option) {
          handleOptionClick(option.name);
        }
        // const numKey = parseInt(event.key);
        // if (!isNaN(numKey) && numKey > 0 && numKey <= options.length) {
        //   const selectedOption = options[numKey - 1];
        //   handleOptionClick(selectedOption);
        // }
      } else {
        const buttons = isPro ? eventButtonsPro : eventButtons;
        const button = buttons.find(
          (btn) => btn.key.toLowerCase() === event.key.toLowerCase()
        );
        if (button && button.value !== "esc") {
          if (flows[button.value]) {
            handleEventClick(button.value);
          }
        }
      }

      if (event.key === "Enter" && canAddEvent) {
        handleAddEvent();
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [
    currentEvent,
    currentStep,
    selectedOptions,
    canAddEvent,
    isVisible,
    isPro,
    multipleSelections,
    keys,
    addNewEvent,
    onEventTimeCaptureClear,
  ]);

  useEffect(() => {
    if (!isPro) return;
    // Additional logic for determining if we should hide buttons (show only Enter button)
    let shouldHideButtonsValue = false;
    // Standalone events that should only show Enter button
    const standaloneEvents = [
      "block_shot",
      "recovery",
      "interception",
      "save",
      "duel_success",
    ];
    if (standaloneEvents.includes(currentEvent) && currentStep === null) {
      shouldHideButtonsValue = true;
    }
    // Events with success/fail that should only show Enter button after selecting success/fail
    else if (
      [
        "dribble",
        "free_kick",
        "tackle",
        "corner",
        "penalty",
        "azamat",
      ].includes(currentEvent) &&
      (selectedOptions?.initial === "success" ||
        selectedOptions?.initial === "fail")
    ) {
      shouldHideButtonsValue = true;
    }

    // Update the state
    setShouldHideButtons(shouldHideButtonsValue);
  }, [
    currentEvent,
    currentStep,
    selectedOptions,
    multipleSelections,
    isFinalStep,
    shouldHideButtons,
    isPro,
  ]);

  const getOptionKey = (eventType, optionName) => {
    if (optionName === "success") return "+";
    else if (optionName === "fail") return "-";

    const eventKeys = keys[eventType]?.options;
    return eventKeys?.find((option) => option.name === optionName)?.key;
  };

  // Add this helper function to get display name for options
  const getOptionDisplayName = (eventType, optionName) => {
    const eventKeys = keys[eventType]?.options;
    const option = eventKeys?.find((option) => option.name === optionName);
    return (
      option?.displayName ||
      optionName.charAt(0).toUpperCase() + optionName.slice(1)
    );
  };

  const renderSelectedOptions = () => {
    if (!currentEvent && Object.keys(selectedOptions).length === 0) return null;

    return (
      <div>
        <div className="tw-rounded-md tw-w-fit tw-border tw-border-solid tw-border-white tw-p-1 tw-grid tw-grid-cols-5 tw-gap-1 tw-bg-white tw-bg-opacity-10">
          {/* Show the initial event */}
          {currentEvent && (
            <span className="tw-p-1 tw-text-xs tw-text-white tw-uppercase tw-text-center tw-min-w-16 tw-bg-[#528048] tw-rounded-md">
              {currentEvent}
            </span>
          )}

          {/* Show selected options in order */}
          {Object.entries(selectedOptions).map(([step, value]) => (
            <span
              key={step}
              className="tw-p-1 tw-text-xs tw-text-white tw-uppercase tw-text-center tw-min-w-16 tw-bg-[#528048] tw-rounded-md"
            >
              {value}
            </span>
          ))}

          {/* Show multiple selections if they exist */}
          {multipleSelections.size > 0 &&
            Array.from(multipleSelections).map((value) => (
              <span
                key={value}
                className="tw-p-1 tw-text-xs tw-text-white tw-uppercase tw-text-center tw-min-w-16 tw-bg-[#528048] tw-rounded-md"
              >
                {value}
              </span>
            ))}
        </div>
      </div>
    );
  };

  const renderCurrentOptions = () => {
    if (!isVisible) {
      return (
        <div className="tw-flex tw-gap-2">
          <EventButton
            label="Show"
            number="Ctrl+E"
            onClick={() => setIsVisible(true)}
          />
        </div>
      );
    }

    // If we should hide buttons, return only the Hide button
    if (shouldHideButtons) {
      return (
        <div className="tw-flex tw-gap-2">
          <EventButton label="Hide" number="ESC" onClick={handleEscape} />
        </div>
      );
    }

    if (!currentEvent || !currentStep) {
      const buttons = isPro ? eventButtonsPro : eventButtons;
      return (
        <div className="tw-flex tw-gap-2">
          {buttons.map((button) => (
            <EventButton
              key={button.value}
              label={button.label}
              number={button.key}
              onClick={() => {
                if (button.value === "esc") {
                  handleEscape();
                } else if ((isPro ? eventFlowsPro : eventFlows)[button.value]) {
                  handleEventClick(button.value);
                }
              }}
            />
          ))}
        </div>
      );
    }

    const flows = isPro ? eventFlowsPro : eventFlows;
    let options = flows[currentEvent]?.[currentStep];
    if (typeof options === "function") {
      options = options(selectedOptions);
    }
    options = options || [];
    return (
      <div className="tw-flex tw-gap-2">
        <EventButton label="Hide" number="ESC" onClick={handleEscape} />
        {options.map((option, index) => (
          <EventButton
            key={option}
            label={getOptionDisplayName(currentEvent, option)}
            number={getOptionKey(currentEvent, option)}
            onClick={() => handleOptionClick(option)}
            isSelected={isFinalStep && multipleSelections.has(option)}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      {renderSelectedOptions()}
      <div className="tw-flex tw-gap-2">
        {renderCurrentOptions()}
        {isVisible && (
          <EventButton
            label="Add Event"
            number="ENTER"
            isWide={true}
            disabled={!canAddEvent}
            onClick={handleAddEvent}
          />
        )}
      </div>
    </div>
  );
};

export default EventControls;
